import { Component } from 'react';
import { connect } from 'react-redux';
import { adminLogout } from '../../../actions/login';

class AdminLogout extends Component {
  UNSAFE_componentWillMount() {
    const { dispatch } = this.props;

    dispatch({type: 'CLEAR_PROFILE'});
    dispatch(adminLogout());
  }

  render() {
    const { processed } = this.props;

    if (processed) {
      window.location.href = '/admin/login';
    }

    return (
      <p>
        Loggin out...
      </p>
    );
  }
}

export default connect(state => ({
  processed: state.logout.processed,
  profile: state.viewConfig.profile,
}))(AdminLogout);
